/**
 * Os conjuntos fechados do catálogo, do lado da tela.
 *
 * Existem aqui, e não dentro de uma tela, porque duas usam: a criação escolhe
 * a classificação inicial e o editor a corrige. Uma segunda cópia divergiria
 * na primeira modalidade nova — e a tela que ficasse para trás ofereceria uma
 * opção que o banco recusa, ou esconderia uma que ele aceita.
 *
 * Quem valida é o servidor, sempre. Isto é a lista que a tela oferece.
 */

export const MODALITIES = [
  'strength',
  'running_walking',
  'functional',
  'mobility',
  'swimming',
] as const;

export const CATEGORIES = [
  'chest',
  'back',
  'shoulders',
  'arms',
  'legs',
  'core',
  'full_body',
  'cardio',
] as const;

export const LEVELS = ['beginner', 'intermediate', 'advanced'] as const;

export const EQUIPMENT = [
  'none',
  'dumbbells',
  'barbell',
  'kettlebell',
  'bands',
  'bench',
  'pullup_bar',
  'machines',
  'cardio_machine',
] as const;
